import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/apiClient";
import { updateUserApiV1AdminUsersUserIdPatch } from "@/api/generated/sdk.gen";
import type { AdminUserUpdateSchema } from "@/api/generated/types.gen";

import { CLIENT_KEYS } from "@constants/clientKeys";

const errText = (error: unknown): string =>
  (error as { detail?: string })?.detail || "Request failed.";

/** Update a user: user_type and/or is_admin / is_blocked flags (admin). */
export const useUpdateAdminUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      userId,
      body,
    }: {
      userId: string;
      body: AdminUserUpdateSchema;
    }) => {
      const response = await updateUserApiV1AdminUsersUserIdPatch({
        client: apiClient,
        path: { user_id: userId },
        body,
      });
      if ("error" in response && response.error) {
        throw new Error(errText(response.error));
      }
      return response.data;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [CLIENT_KEYS.ADMIN_USERS] }),
  });
};
